<template>
    <figure class="content-new-video" :class="`layout-${layout}`">
      <div class="video-container">
        <div class="video-wrapper">
          <video 
            :src="videoUrl"
            playsinline
            preload="metadata" 
            controls
            :poster="thumbnailUrl"
            class="responsive-video"
            @click="toggleOverlay(1)"
          ></video>
          <div v-if="overlayIndex === 1" class="video-overlay" @click="toggleOverlay(0)">
            <div class="overlay-content">
              <button class="close-button" @click.stop="toggleOverlay(0)">×</button>
              <video :src="videoUrl" controls autoplay class="fullscreen-video"></video>
            </div>
          </div>
        </div>
      </div>
      
      <figcaption class="video-info">
        <h3 class="video-title">{{ title }}</h3>
        <div class="video-description" v-html="description"></div>
      </figcaption>
    </figure>
  </template>
  
  <script>
  export default {
    components: {},
    props: {
      title: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      file: {
        type: [String, Object],
        default: ''
      },
      thumbnail: {
        type: [String, Object],
        default: ''
      },
      layout: {
        type: String,
        default: 'center'
      }
    },
    data() {
      return {
        overlayIndex: 0,
      };
    },
    computed: {
      videoUrl() {
        if (typeof this.file === 'object' && this.file.url) {
          return this.file.url;
        }
        return this.file;
      },
      thumbnailUrl() {
        if (typeof this.thumbnail === 'object' && this.thumbnail.url) {
          return this.thumbnail.url;
        }
        return this.thumbnail;
      }
    },
    methods: {
      toggleOverlay(index) {
        if (window.innerWidth < 768) {
          return false;
        }
        this.overlayIndex = index;
        if (index === 1) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      },
    },
  }
  </script>
  
  <style scoped>
  .content-new-video {
    margin: 2rem 0;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .video-container {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
  }
  
  .video-wrapper {
    position: relative;
    padding-top: 140%; /* 5:7 aspect ratio (7/5 = 1.4 = 140%) */
    height: 0;
    overflow: hidden;
    border-radius: 2px;
  }
  
  .responsive-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: #000;
  }
  
  .video-info {
    margin-top: 1rem;
  }
  
  .video-title {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
  }
  
  .video-description {
    font-size: 1rem;
    line-height: 1.5;
  }
  
  .video-description p {
    margin-bottom: 0.75rem;
  }
  
  /* Layout variations */
  .layout-left, .layout-right {
    display: flex;
    flex-direction: column;
  }
  
  @media (min-width: 769px) {
    .content-new-video {
      flex-direction: row;
      flex-wrap: wrap;
      gap: 2rem;
    }
    
    .layout-left {
      flex-direction: row;
    }
    
    .layout-right {
      flex-direction: row-reverse;
    }
    
    .layout-left .video-container,
    .layout-right .video-container {
      width: 40%;
    }
    
    .layout-left .video-info,
    .layout-right .video-info {
      width: calc(60% - 2rem);
      margin-top: 0;
    }
  }
  
  /* Overlay for fullscreen video */
  .video-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
  }
  
  .overlay-content {
    position: relative;
    width: 90%;
    max-width: 1200px;
  }
  
  .fullscreen-video {
    width: 100%;
    max-height: 90vh;
  }
  
  .close-button {
    position: absolute;
    top: -40px;
    right: 0;
    background: none;
    border: none;
    color: white;
    font-size: 2rem;
    cursor: pointer;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .content-new-video {
      margin: 1.5rem 0;
    }
    
    .video-title {
      font-size: 1.25rem;
    }
    
    .video-description {
      font-size: 0.9rem;
    }
  }
  </style>



// WEBPACK FOOTER //
// public/js/components/content/ContentNewVideo.vue